/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import $ from 'jquery';
import axios from 'axios';
import './style.scss';

const ModalAction = ({ application, setApplication }) => {
  const [isHiddenForm, setIsHiddenForm] = useState('1');
  const [note, setNote] = useState('');
  const handlerChooseOption = (value) => {
    setIsHiddenForm(value);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    $('#modal-action').removeClass('show').css('display', 'none');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    axios
      .post('api/v1/dashboard/platform/status', {
        user_id: application?.id,
        status: isHiddenForm,
        note,
      })
      .then(({ data }) => {
        if (data.success) {
          // application.status = 1;
          setApplication({ ...application });
        }
      });
  };
  return (
    <div className='modal fade modal-action' id='modal-action'>
      <div className='modal-dialog modal-dialog-centered' role='document'>
        <div className='modal-content'>
          <h5 className='text-center like-title p-3'>
            Cập nhật trạng thái yêu cầu sử dụng dịch vụ
          </h5>
          <h5 className='text-center like-title'>
            Đơn vị yêu cầu: {application?.name}
          </h5>
          <div className='option-select'>
            <div className='input-group'>
              <input
                id='sscomplete'
                type='radio'
                name='status'
                value='1'
                onClick={(e) => {
                  handlerChooseOption(e.target.value);
                }}
                checked={isHiddenForm === '1'}
              />
              <label htmlFor='sscomplete'>Hoàn thành</label>
            </div>
            <div className='input-group'>
              <input
                id='ssdeny'
                type='radio'
                name='status'
                value='2'
                onClick={(e) => {
                  handlerChooseOption(e.target.value);
                }}
                checked={isHiddenForm === '2'}
              />
              <label htmlFor='ssdeny'>Từ chối</label>
            </div>
          </div>
          <form
            onSubmit={(e) => {
              handleLogin(e);
            }}
          >
            <div className='tab-content'>
              <div id='personal' className='tab-pane fade show active'>
                {isHiddenForm !== '1' && (
                  <div className='form-group'>
                    <label>Ghi chú</label>
                    <textarea
                      type='text'
                      name='note'
                      placeholder=''
                      onChange={(e) => {
                        setNote(e.target.value);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <button type='submit' className='btn_submit flex-center'>
              Lưu
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModalAction;
